module.exports = __webpack_public_path__ + "img/logout.f8688c67.svg";